import {ref} from "vue";
import {getTopic, getTopicPageData} from "@/api/CommonApi";

/**
 * 栏目分页数据 对象
 *
 * 示例：
 * setup(props){
        // 初始化栏目分页数据 topicCode是父栏目的code
        const obj = new TopicPageList(props.topicCode)
        // 绑定函数，不能直接return对象的函数，会导致this不正确
        const loadTopicPageData = (topicCode,params) => obj.loadTopicPageData(topicCode,params)
        const loadTopicData = (topicCode) => obj.loadTopicData(topicCode)
        const initTopicPageListObj = (topicCode) => obj.init(topicCode)

        return{
            topicPageListObj:obj,
            // 加载指定栏目数据
            loadTopicPageData,
            // 加载栏目数据
            loadTopicData,
            // 初始化TopicPageList对象
            initTopicPageListObj,
            // 栏目信息
            topicData:obj.topicData,
            // 子栏目信息
            childTopics:obj.childTopics,
            // 各栏目分页数据
            topicsPageData:obj.topicsPageData,

        }
    },
 *
 */
export default class TopicPageList{

    /** 栏目信息 */
    topicCode
    /** 栏目信息 */
    topicData = ref({})
    /** 子栏目信息 */
    childTopics = ref([])
    /** 各栏目分页数据 */
    topicsPageData = ref({})
    /** 默认请求的分页参数 */
    defaultParams

    /**
     * 构造函数，实际上会调用init(topicCode,defaultParams)
     * @param topicCode 栏目code
     * @param defaultParams 默认请求分页的params
     */
    constructor(topicCode,defaultParams){
        this.init(topicCode,defaultParams)
    }

    /**
     * 初始化
     * @param topicCode 栏目code
     * @param defaultParams 默认请求分页的params
     */
    init(topicCode,defaultParams){
        this.topicCode = topicCode
        this.topicData.value = {}
        this.childTopics.value = []
        this.topicsPageData.value = {}
        this.defaultParams = defaultParams || {}
        // 栏目 - 全部数据
        this.topicsPageData.value[topicCode] = {
            list:[], // 列表数据-空
            loading:false, // 是否正在加载
            page:0, // 当前所在页面
            finished:false,
        }
        // 加载栏目数据
        this.loadTopicData(topicCode)
        // 加载父栏目分页数据
        this.loadTopicPageData(topicCode)
    }

    /**
     * 加载栏目数据
     * @param topicCode 栏目code
     */
    loadTopicData(topicCode){
        getTopic(topicCode).then(res => {
            const result = res.result || {}
            this.topicData.value = result
            this.childTopics.value = result.child || []

            // 设置各栏目的数据
            for(let item of this.childTopics.value){
                this.initTopicPageData(item.code)
            }
        })
    }

    /**
     * 加载指定栏目数据
     */
    loadTopicPageData(topicCode,params = {page:'next',...this.defaultParams}){
        // 初始化栏目
        this.initTopicPageData(topicCode)
        // 栏目分页数据
        const pageData = this.topicsPageData.value[topicCode]
        // 栏目加载中 || 栏目数据加载完毕 退出
        if(pageData.loading || pageData.finished) return;
        // 设置分页参数
        if(params.page === 'next'){
            params.page = pageData.page + 1 // 下一页
        }

        // 设置加载中
        pageData.loading = true

        // 调用http接口，加载数据
        getTopicPageData(topicCode,params).then(res => {
            const result = res.result
            if(!result){
                pageData.finished = true
                return
            }
            pageData.page = result.current // 当前页码
            pageData.finished = result.current >= result.pages // 是否加载完毕
            pageData.list = [...pageData.list,...result.records] // 数据列表
        }).finally(() => {
            pageData.loading = false
        })
    }

    /** 初始化 指定栏目 的分页数据 */
    initTopicPageData(topicCode){
        if(!this.topicsPageData.value[topicCode]){
            this.topicsPageData.value[topicCode] = {
                list:[], // 列表数据-空
                loading:false, // 是否正在加载
                page:0, // 当前所在页面
                finished:false, // 是否全部加载完成
            }
        }
    }
}
